import React, { useState, useEffect } from 'react';
import { Cat, RefreshCw, Sparkles, Heart } from 'lucide-react';
import apiService from '../services/api';

const CatPicturePage = () => {
  const [catData, setCatData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCatPicture();
  }, []);

  const loadCatPicture = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getCatPicture();
      setCatData(response);
    } catch (err) {
      console.error('Error loading cat picture:', err);
      setError('Failed to load cat picture. Try again!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-orange-50 dark:from-pink-950 dark:via-purple-950 dark:to-orange-950 flex items-center justify-center p-4 transition-colors">
      <div className="max-w-3xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Heart className="h-8 w-8 text-pink-500 dark:text-pink-400 animate-pulse" />
            <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-orange-600 dark:from-pink-400 dark:to-orange-400 mx-3">
              Hello Sofia!
            </h1>
            <Heart className="h-8 w-8 text-pink-500 dark:text-pink-400 animate-pulse" />
          </div>
          <p className="text-lg text-gray-600 dark:text-gray-300">Here's a cute cat just for you!</p>
        </div>

        {/* Cat Picture Card */}
        <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 mb-6 transform transition-all hover:scale-105">
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-r from-pink-500 to-orange-500 dark:from-pink-600 dark:to-orange-600 rounded-full p-4">
              <Cat className="h-12 w-12 text-white" />
            </div>
          </div>

          {loading ? (
            <div className="text-center py-12">
              <RefreshCw className="h-12 w-12 animate-spin mx-auto text-pink-600 dark:text-pink-400 mb-4" />
              <p className="text-gray-600 dark:text-gray-300">Finding a cute cat...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-600 dark:text-red-400 text-lg">{error}</p>
            </div>
          ) : catData ? (
            <div className="flex justify-center">
              <div className="w-full h-[500px] flex items-center justify-center">
                <img
                  src={catData.url}
                  alt="Random cat"
                  className="max-w-full max-h-full object-contain rounded-2xl shadow-lg"
                  onError={(e) => {
                    e.target.src = 'https://cataas.com/cat';
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>

        {/* Refresh Button */}
        <div className="flex justify-center">
          <button
            onClick={loadCatPicture}
            disabled={loading}
            className="group relative inline-flex items-center px-8 py-4 bg-gradient-to-r from-pink-600 to-orange-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl transform transition-all hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          >
            <RefreshCw className={`h-6 w-6 mr-3 ${loading ? 'animate-spin' : 'group-hover:rotate-180 transition-transform duration-500'}`} />
            {loading ? 'Loading...' : 'Another Cutie!'}
          </button>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Powered by AI cat picture technology
          </p>
        </div>
      </div>
    </div>
  );
};

export default CatPicturePage;
